


























import { Vue, Component, Prop, Model } from 'vue-property-decorator';
import { ELabelSize, BaseLabel } from '../base-label';

@Component({
  name: 'BaseSwitch',
  components: {
    BaseLabel,
  },
  data: () => ({
    ELabelSize,
  }),
})
export default class BaseSwitch extends Vue {
  @Model('update', { default: false }) value: boolean;
  @Prop({ default: false }) disabled: boolean;
  @Prop() label: string;
  @Prop() id: string;

  changeValue() {
    if (this.disabled) {
      return;
    }
    this.$emit('update', !this.value);
  }

  get switchId(): string {
    return this.id || `input-switch-${this['_uid']}`;
  }

  get switchLabelId(): string {
    return `input-switch-label-${this['_uid']}`;
  }
}
